import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi } from '@/services/api/auth'
import { useAuthStore } from '@/store'
import { resolvePostLoginPath } from '@/utils/authRedirect'
import { setTokens } from '@/utils/tokenStorage'

interface SchoolOpt {
  id: string
  name: string
}

export function EngineerSchoolSelectPage() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const raw = sessionStorage.getItem('engineer_schools')
  let schools: SchoolOpt[] = []
  try {
    schools = raw ? JSON.parse(raw) : []
  } catch {
    schools = []
  }

  const pick = async (schoolId: string) => {
    setBusy(true)
    setError(null)
    try {
      const res = await authApi.selectEngineerSchool(schoolId)
      setTokens(res.access_token, res.refresh_token)
      useAuthStore.setState({ user: res.user, isAuthenticated: true })
      await useAuthStore.getState().fetchAvailableRoles()
      sessionStorage.removeItem('engineer_schools')
      navigate(resolvePostLoginPath(res.user.role), { replace: true })
    } catch {
      setError('Schule konnte nicht gewählt werden.')
    } finally {
      setBusy(false)
    }
  }

  if (schools.length === 0) {
    return (
      <div className="max-w-md mx-auto p-8">
        <p className="text-gray-600">Keine Schulen zur Auswahl.</p>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto p-8">
      <h1 className="text-xl font-bold mb-4">Schule wählen</h1>
      <p className="text-sm text-gray-500 mb-4">Du bist an mehreren Schulen Engineer. Wähle die Schule für diese Sitzung.</p>
      {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
      <div className="space-y-2">
        {schools.map((s) => (
          <button
            key={s.id}
            disabled={busy}
            onClick={() => pick(s.id)}
            className="w-full text-left px-4 py-3 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            {s.name}
          </button>
        ))}
      </div>
    </div>
  )
}
